<fb-loader *ngIf="loading"></fb-loader>
<section *ngIf="!loading" class="fb-product w-full flex flex-col justify-center items-center mb-6 md:my-6">
	<div class="w-full max-w-[1290px] flex flex-col md:flex-row gap-4 relative ">
		<div class="w-full md:flex-[50%] fb-font-inter ">
			<div *ngIf="isMd" class="text-xs grey-text capitalize mb-4">
				<a routerLink="/">Home</a> / <a *ngIf="product.category.name.toLowerCase() !== 'fabrics'" href="/products/{{product.productGroup}}?category={{prepareUrl(product.category.name)}}">{{ product.category.name.toLowerCase()}} / </a>
				<a *ngIf="product.category.name.toLowerCase() !== 'fabrics'" href="/products/{{product.productGroup}}?category={{prepareUrl(product.category.name)}}&{{prepareUrl(product.segment.name)}}={{prepareUrl(product.subCategory.name)}}">{{ product.subCategory.name.toLowerCase()}}</a>
				<a *ngIf="product.category.name.toLowerCase() === 'fabrics'" href="/products/{{product.productGroup}}?{{prepareUrl(product.segment.name)}}={{prepareUrl(product.subCategory.name)}}">{{ product.subCategory.name.toLowerCase()}}</a>
			</div>
			<fb-product-light-gallery [galleryItems]="productGallery"
									  [hasVideo]="!!product.productVideo"
									  [selectedFabric]="selectedFabric"
									  [productFinish]="product.productGroup === 'finished'"></fb-product-light-gallery>
			<fb-product-description *ngIf="isMd" [product]="product"></fb-product-description>
		</div>
		<div class=" md:flex-[50%] flex flex-col gap-2 mx-3 xl:mx-0 box-border fb-font-inter">
			<div *ngIf="!isMd" class="text-xs grey-text capitalize mb-2">
				<a routerLink="/">Home</a> / <a *ngIf="product.category.name.toLowerCase() !== 'fabrics'" href="/products/{{product.productGroup}}?category={{prepareUrl(product.category.name)}}">{{ product.category.name.toLowerCase()}} / </a>
				<a *ngIf="product.category.name.toLowerCase() !== 'fabrics'" href="/products/{{product.productGroup}}?category={{prepareUrl(product.category.name)}}&{{prepareUrl(product.segment.name)}}={{prepareUrl(product.subCategory.name)}}">{{ product.subCategory.name.toLowerCase()}}</a>
				<a *ngIf="product.category.name.toLowerCase() === 'fabrics'" href="/products/{{product.productGroup}}?{{prepareUrl(product.segment.name)}}={{prepareUrl(product.subCategory.name)}}">{{ product.subCategory.name.toLowerCase()}}</a>
			</div>
			<div class="flex justify-between items-center">
				<div class="flex gap-1.5">
					<div *ngIf="product.madeToOrderProfileEnabled && !orderTypeInStock" class="f-mto">
						Made To Order
						<span class="close material-symbols-outlined info_icon text-xs">info</span>
					</div>
					<div *ngIf="this.product.specialStatus" class="f-g-badge">
						{{this.product.specialStatus.name}}
					</div>
				</div>
				<div class="flex gap-1.5">
					<fb-product-share-icon [productName]="product.name"
										   [productDescription]="product.metaDescription"></fb-product-share-icon>
					<fb-product-wishlist-icon [productName]="product.name"
											  [productSku]="product.sku"></fb-product-wishlist-icon>
				</div>
			</div>


			<h1 class="fb-font-dm fb-product-header">{{this.product.name}}</h1>

			<fb-product-sku [value]="product.sku"></fb-product-sku>

			<div (click)="showReviews()"
				 class="flex gap-1.5 items-center fb-light-text text-sm md:text-base cursor-pointer">
				<div class="star">&#9733;</div>
				<div class="fb-medium-text">{{rating-0.2}}</div>
				|
				<div>({{reviewCount}} reviews)</div>
			</div>

			<fb-product-price class="mt-2" [product]="product"
							  [price]="calculatedPrice"
							  [discountedPrice]="calculatedDiscountPrice"
							  [fabricSelected]="!!selectedFabric"></fb-product-price>
			<fb-product-bulk-discount class="mt-1"
									  *ngIf="product.volumeDiscountProfileEnabled && product.volumeDiscountProfile"
									  [product]="product"
									  [calculatedPrice]="calculatedPrice"
									  [selectedFabric]="selectedFabric"
									  [selectedFinishPrice]="selectedFinishPrice"
									  [customSizePrice]="customSizePrice"
									  [volumeDiscountProfile]="product.volumeDiscountProfile"></fb-product-bulk-discount>
			<fb-product-composition *ngIf="product.productGroup !== 'finished'" class="mt-2"
									[weight]="productResponse.width"
									[gsm]="product.category.name.toLowerCase() === 'swatchkit'? 0: productResponse.gsm"></fb-product-composition>
			<div *ngIf="product.relatedProductList && product.relatedProductList.length > 1"
				 class="mt-2">
				<fb-product-variant [productSku]="product.sku"
									[relatedList]="product.relatedProductList"
									[productCategory]="urlCategory"></fb-product-variant>
			</div>
			<div *ngIf="product.productGroup ==='finished' && product.sizeProfileEnabled && product.sizeProfile"
				 class="mt-2">
				<fb-product-size-profile [product]="product"
										 [sizeProfile]="product.sizeProfile"
										 (sizeSelected)="onSizeSelected($event)"
										 (customSizeSelected)="onCustomSizeSelected($event)"></fb-product-size-profile>
			</div>
			<fb-product-quantity-input class="mt-1"
									   [product]="product"
									   [unit]="product.unit"
									   [minOrderQuantity]="minimumOrderQuantity"
									   [calculatedQuantityInStock]="quantityInStock"
									   [stockMessage]="stockMessage"
									   (quantityChange)="onQuantityChange($event)"></fb-product-quantity-input>
			<div *ngIf="product.madeToOrderProfileEnabled"
				 (click)="showCustomization()"
				 class="fb-customization-card flex flex-col gap-2 mt-3 mb-2">
				<div class="flex gap-2 items-center">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M3.49704 14.044L10.519 7.023C10.9863 6.56242 11.3573 6.01347 11.6104 5.40812C11.8634 4.80277 11.9935 4.15312 11.993 3.497C11.9931 2.18896 11.4796 0.933188 10.563 0L3.54004 7.024C3.07302 7.48451 2.70227 8.03333 2.44938 8.63851C2.1965 9.24368 2.06653 9.89311 2.06704 10.549C2.06704 11.922 2.61704 13.149 3.49704 14.045V14.044ZM20.504 9.941L13.481 16.963C13.0141 17.4235 12.6433 17.9724 12.3905 18.5775C12.1376 19.1827 12.0076 19.8321 12.008 20.488C12.008 21.848 12.558 23.089 13.438 23.985L20.46 16.963C20.9275 16.5025 21.2985 15.9536 21.5516 15.3482C21.8047 14.7428 21.9347 14.0931 21.934 13.437C21.934 12.064 21.384 10.837 20.504 9.941ZM20.46 7.037C20.9273 6.5766 21.2983 6.02783 21.5513 5.42264C21.8044 4.81746 21.9345 4.16796 21.934 3.512C21.934 2.152 21.384 0.912 20.504 0.015L3.54004 16.965C2.60422 17.8937 2.07431 19.1552 2.06626 20.4736C2.0582 21.792 2.57264 23.0599 3.49704 24L20.46 7.037Z" fill="#275E49"/>
					</svg>
					<h2 class="fb-font-dm text-lg md:text-xl">Customization Available</h2>
				</div>
				<div class="flex flex-col gap-2 justify-center items-start">
					<p class="text-[#3c3c3c] text-sm md:text-base">
						This product is available with customized fabrics, natural custom dyeing  at low MOQ
					</p>
					<button class="text-[#275E49] bg-white rounded border border-[#D1D4DB] px-4 py-1 text-sm">
						Show Customization Options >
					</button>
				</div>
			</div>
			<fb-product-cart-buttons class="w-full md:w-auto mt-2 fixed md:relative bottom-0 left-0 z-[2]"
									 [product]="product"
									 [productId]="productResponse.id"
									 [minOrderQuantity]="minimumOrderQuantity"
									 [selectedFabricId]="selectedFabric? selectedFabric.fabricPreview.id : product.fabricProfileEnabled && product.madeToOrderFabric? product.madeToOrderFabric.id : 0"
									 [selectedSizeId]="this.selectedSize? this.selectedSize.id : 0"
									 [calculatedQuantityInStock]="quantityInStock"
									 (addToCart)="addProductToCart()"></fb-product-cart-buttons>
			<fb-product-swatch-button class="mt-2"
									  *ngIf="productResponse.addToSwatch && !customizationSelected"
									  [fabricProductId]="productResponse.id"
									  [product]="product"></fb-product-swatch-button>

			<div *ngIf="product.madeToOrderProfileEnabled && product.madeToOrderProfile && !orderTypeInStock"
				 class="flex gap-2 items-center mt-1">
				<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g clip-path="url(#clip0_2116_153)">
						<path d="M28.05 15.5719L25.2375 9.00937C25.1657 8.83992 25.0457 8.69534 24.8923 8.59365C24.7389 8.49196 24.559 8.43765 24.375 8.4375H21.5625V6.5625C21.5625 6.31386 21.4637 6.0754 21.2879 5.89959C21.1121 5.72377 20.8736 5.625 20.625 5.625H2.8125C2.56386 5.625 2.3254 5.72377 2.14959 5.89959C1.97377 6.0754 1.875 6.31386 1.875 6.5625V22.5C1.875 22.7486 1.97377 22.9871 2.14959 23.1629C2.3254 23.3387 2.56386 23.4375 2.8125 23.4375H4.81875C5.03464 24.2319 5.50594 24.9332 6.15993 25.4332C6.81393 25.9332 7.61428 26.2041 8.4375 26.2041C9.26072 26.2041 10.0611 25.9332 10.7151 25.4332C11.3691 24.9332 11.8404 24.2319 12.0562 23.4375H17.9437C18.1596 24.2319 18.6309 24.9332 19.2849 25.4332C19.9389 25.9332 20.7393 26.2041 21.5625 26.2041C22.3857 26.2041 23.1861 25.9332 23.8401 25.4332C24.4941 24.9332 24.9654 24.2319 25.1813 23.4375H27.1875C27.4361 23.4375 27.6746 23.3387 27.8504 23.1629C28.0262 22.9871 28.125 22.7486 28.125 22.5V15.9375C28.1248 15.8118 28.0993 15.6875 28.05 15.5719ZM21.5625 10.3125H23.7563L25.7625 15H21.5625V10.3125ZM8.4375 24.375C8.06666 24.375 7.70415 24.265 7.39581 24.059C7.08746 23.853 6.84714 23.5601 6.70523 23.2175C6.56331 22.8749 6.52618 22.4979 6.59853 22.1342C6.67087 21.7705 6.84945 21.4364 7.11167 21.1742C7.3739 20.912 7.70799 20.7334 8.07171 20.661C8.43542 20.5887 8.81242 20.6258 9.15503 20.7677C9.49764 20.9096 9.79048 21.15 9.99651 21.4583C10.2025 21.7666 10.3125 22.1292 10.3125 22.5C10.3125 22.9973 10.115 23.4742 9.76332 23.8258C9.41169 24.1775 8.93478 24.375 8.4375 24.375ZM17.9437 21.5625H12.0562C11.8404 20.7681 11.3691 20.0668 10.7151 19.5668C10.0611 19.0668 9.26072 18.7959 8.4375 18.7959C7.61428 18.7959 6.81393 19.0668 6.15993 19.5668C5.50594 20.0668 5.03464 20.7681 4.81875 21.5625H3.75V7.5H19.6875V19.275C19.2606 19.5228 18.8868 19.8524 18.5876 20.2449C18.2884 20.6375 18.0696 21.0852 17.9437 21.5625ZM21.5625 24.375C21.1917 24.375 20.8291 24.265 20.5208 24.059C20.2125 23.853 19.9721 23.5601 19.8302 23.2175C19.6883 22.8749 19.6512 22.4979 19.7235 22.1342C19.7959 21.7705 19.9745 21.4364 20.2367 21.1742C20.4989 20.912 20.833 20.7334 21.1967 20.661C21.5604 20.5887 21.9374 20.6258 22.28 20.7677C22.6226 20.9096 22.9155 21.15 23.1215 21.4583C23.3275 21.7666 23.4375 22.1292 23.4375 22.5C23.4375 22.9973 23.24 23.4742 22.8883 23.8258C22.5367 24.1775 22.0598 24.375 21.5625 24.375ZM26.25 21.5625H25.1813C24.9739 20.7596 24.5063 20.048 23.8515 19.5391C23.1968 19.0302 22.3918 18.7527 21.5625 18.75V16.875H26.25V21.5625Z" fill="#7D5A20"/>
					</g>
					<defs>
						<clipPath id="clip0_2116_153">
							<rect width="30" height="30" fill="white"/>
						</clipPath>
					</defs>
				</svg>
				<div class="flex flex-wrap gap-1.5 items-center text-sm md:text-base">
					<div class="flex flex-wrap items-center gap-1.5">
						<div class="f-mto">
							Made To Order
							<span class="close material-symbols-outlined info_icon text-xs">info</span>
						</div> Estimated Date Of Delivery
					</div>

					<br/>
					<span class="font-bold">{{(fromDays | formatDate).split(',')[0]}} to {{toDays | formatDate}}</span>
				</div>
			</div>

			<fb-product-tabs class="mt-2"
							 *ngIf="!isMd"
							 [activeTab]="activeTab"
							 [showCustomizationTab]="product.madeToOrderProfileEnabled"
							 (tabChange)="activeTab = $event"></fb-product-tabs>
			<div *ngIf="product.madeToOrderProfileEnabled && activeTab === 'customization'"
				 #customization
				 class="flex flex-col gap-3 mb-2">
				<div *ngIf="isMd" class="flex gap-2 items-center mt-4">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M3.49704 14.044L10.519 7.023C10.9863 6.56242 11.3573 6.01347 11.6104 5.40812C11.8634 4.80277 11.9935 4.15312 11.993 3.497C11.9931 2.18896 11.4796 0.933188 10.563 0L3.54004 7.024C3.07302 7.48451 2.70227 8.03333 2.44938 8.63851C2.1965 9.24368 2.06653 9.89311 2.06704 10.549C2.06704 11.922 2.61704 13.149 3.49704 14.045V14.044ZM20.504 9.941L13.481 16.963C13.0141 17.4235 12.6433 17.9724 12.3905 18.5775C12.1376 19.1827 12.0076 19.8321 12.008 20.488C12.008 21.848 12.558 23.089 13.438 23.985L20.46 16.963C20.9275 16.5025 21.2985 15.9536 21.5516 15.3482C21.8047 14.7428 21.9347 14.0931 21.934 13.437C21.934 12.064 21.384 10.837 20.504 9.941ZM20.46 7.037C20.9273 6.5766 21.2983 6.02783 21.5513 5.42264C21.8044 4.81746 21.9345 4.16796 21.934 3.512C21.934 2.152 21.384 0.912 20.504 0.015L3.54004 16.965C2.60422 17.8937 2.07431 19.1552 2.06626 20.4736C2.0582 21.792 2.57264 23.0599 3.49704 24L20.46 7.037Z" fill="#275E49"/>
					</svg>
					<h2 class="fb-font-dm text-xl tracking-wide">Customization Options</h2>
				</div>
				<fb-product-custom-fabric-profile *ngIf="product.fabricProfileEnabled && product.fabricProfile"
												  [product]="product"
												  [fabricProfile]="product.fabricProfile"
												  (fabricSelected)="fabricSelected($event)"></fb-product-custom-fabric-profile>
				<div *ngIf="product.productGroup ==='fabric' && product.sizeProfileEnabled && product.sizeProfile"
					 class="mb-2">
					<fb-product-size-profile [product]="product"
											 [sizeProfile]="product.sizeProfile"
											 (sizeSelected)="onSizeSelected($event)"
											 (customSizeSelected)="onCustomSizeSelected($event)"></fb-product-size-profile>

				</div>
				<fb-product-finish-profile *ngIf="product.finishProfileEnabled && product.finishProfile"
										   [product]="product"
										   [finishProfile]="product.finishProfile"
										   (finishSelectionChange)="finishSelectionChange($event)"></fb-product-finish-profile>
			</div >
			<div *ngIf="!isMd && activeTab === 'description'">
				<fb-product-description [product]="product"></fb-product-description>
			</div>
			<fb-product-content-cards *ngIf="isMd && !product.madeToOrderProfileEnabled"
									  [madeToOrderEnabled]="product.madeToOrderProfileEnabled"
									  [productId]="productResponse.id"
									  [isSizeMd]="isMd"></fb-product-content-cards>
		</div>
	</div>
	<div class="w-full max-w-[1290px] flex flex-col gap-4 ">
<!--		<div class="w-full flex flex-col md:flex-row gap-4 justify-center md:justify-between items-start mt-4">-->
<!--			<div *ngIf="isMd && !product.madeToOrderProfileEnabled"-->
<!--				 class="w-full flex-[40%] flex flex-col justify-center items-center ">-->
<!--				<h2 class="fb-sub-header fb-font-dm text-lg sm:text-xl black-text font-medium lg:px-10 my-2">-->
<!--					About This Product-->
<!--				</h2>-->
<!--				<fb-product-description [product]="product" class="w-full"></fb-product-description>-->
<!--			</div>-->

<!--			<div #reviewSection class="flex-[60%]">-->
<!--				<fb-product-review-section [reviewCount]="reviewCount"-->
<!--										   [rating]="rating - 0.2"-->
<!--										   [productId]="product.id"></fb-product-review-section>-->
<!--			</div>-->
<!--		</div>-->
		<div #reviewSection class="mt-4">
							<fb-product-review-section [reviewCount]="reviewCount"
													   [rating]="rating - 0.2"
													   [productId]="product.id"></fb-product-review-section>
		</div>
		<fb-product-content-cards *ngIf="!isMd || product.madeToOrderProfileEnabled"
								  [productId]="productResponse.id"
								  [madeToOrderEnabled]="product.madeToOrderProfileEnabled"
								  [isSizeMd]="isMd"></fb-product-content-cards>
	</div>
</section>
